import { vincularUsuarioGrupo } from "../../../Interfaces/Geral/Grupos/GruposUsuarioInterface";
import {
    ListarUsuariosPorGrupoService,
    VincularGruposUsuarioService,
    DesVincularGruposUsuarioService,
    ListarGruposVinculadosPorUsuarioService,
    ListarGruposNaoVinculadosPorUsuarioService,
    ListarUsuariosPorGrupoNaoVinculadosService,
    DesVincularUsuarioGrupoService,
} from "../../../Services/Geral/Grupos/GruposUsuariosService";

import { Controller } from "../../Controller";

export function VincularGruposUsuarioController(
    requestBody: vincularUsuarioGrupo[]
) {
    return Controller(VincularGruposUsuarioService(requestBody));
}

export function DesVincularGruposUsuarioController(idGrupoUsuario: number[]) {
    return Controller(DesVincularGruposUsuarioService(idGrupoUsuario));
}

export function ListarGruposVinculadosPorUsuarioController(idGrupo: number) {
    return Controller(ListarGruposVinculadosPorUsuarioService(idGrupo));
}

export function ListarGruposNaoVinculadosPorUsuarioController(
    idUsuario: number
) {
    return Controller(ListarGruposNaoVinculadosPorUsuarioService(idUsuario));
}

export function ListarUsuariosPorGrupoController(idGrupo: number) {
    return Controller(ListarUsuariosPorGrupoService(idGrupo));
}

export function ListarUsuariosPorGrupoNaoVinculadosController(IDGrupo: number) {
    return Controller(ListarUsuariosPorGrupoNaoVinculadosService(IDGrupo));
}

export function DesVincularUsuarioGrupoController(
    idGrupo: number,
    requestBody: number[]
) {
    return Controller(DesVincularUsuarioGrupoService(idGrupo, requestBody));
}
